import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getAllCountries: async (querys) => {
    const url = urlQueryData(`${API_URL}/CatalogueManagement/api/amx/cpe/countries`, querys)
    const response = await fetchManager(url)
    return response
  },
  reOrderCountries: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/countries/order`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  addCountry: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/countries`, {
        method: 'POST',
        data,
      })
    return response
  },
  editCountry: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/countries`, {
        method: 'PUT',
        data,
      })
    return response
  },
  updateVisibilityCountry: async (id, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/countries/visibility/${id}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  getCountriesOfficials: async () => {
    const options = {
      sendToken: false
    }
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/process/countries/officials`, options)
    return response
  },
}